import { Combobox } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { SELECT_ALL_ITEM_ID } from "app/pages/sales-intelligence/constants/common";

type SelectAllOptionProps = {
    label: string;
    isFullSelection: boolean;
    isPartiallySelected: boolean;
    onSelectAll: () => void;
};

const SelectAllOption = ({ label, isFullSelection, isPartiallySelected, onSelectAll }: SelectAllOptionProps) => (
    <Combobox.Option
        key={SELECT_ALL_ITEM_ID}
        id={SELECT_ALL_ITEM_ID}
        textValue={label}
        onClick={onSelectAll}
    >
        <Flex
            alignItems="center"
            justifyContent="space-between"
            gap="8px"
            width="100%"
        >
            <Combobox.OptionLabel>{label}</Combobox.OptionLabel>
            <Combobox.OptionCheckbox
                isChecked={isFullSelection}
                halfSelected={isPartiallySelected}
            />
        </Flex>
    </Combobox.Option>
);

export default SelectAllOption;
